/**
 * Shared Socket.IO client options for every connection the TMA opens to the
 * qgammon-gameserver (the live match socket, the ranked-queue listener and the
 * invite listener).
 *
 * WHY THIS EXISTS: the gameserver now rate-limits the handshake and rejects the
 * excess with `too_many_connections` (per user: 10 burst then 30/min; per IP
 * pre-auth: 30 burst then 60/min — deliberately generous because mobile CGNAT
 * puts many legitimate players behind one address). A rejected handshake is a
 * `connect_error`, and Socket.IO answers a connect_error by RECONNECTING —
 * with its stock settings that is one attempt every 1–5s, i.e. up to ~40/min
 * from a single WebView, which sits right on top of the per-user budget and
 * turns a transient rejection into a self-sustaining loop.
 *
 * So we stretch the ceiling: the same 1s first retry (a genuine network blip
 * still recovers fast) but backing off to 20s instead of 5s, with the full ±50%
 * jitter so several reloading clients don't resynchronise into a thundering
 * herd. Reconnection stays enabled and unlimited — a Telegram WebView that
 * suspends and resumes MUST come back on its own.
 */
export const QGAMMON_SOCKET_OPTIONS = {
  // Mutable array on purpose — socket.io-client's ManagerOptions types
  // `transports` as `string[]`, so `as const` would not assign.
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionDelay: 1_000,
  reconnectionDelayMax: 20_000,
  randomizationFactor: 0.5,
};
